import { useInsights } from '@/stores/insights/insights';
import { DEMOGRAPHIC_SURVEY_SHOW } from '@/helpers/constants/demographicSurveyVersions';
import { hiringReportToOtherReport, otherReportToHiringReport } from './constants/reportingWarnings';

export const routingFromHiringReport = ({ from, to }) => {
  if (from.name === 'hiring-report' && to.name !== 'recruiting-performance') {
    useInsights().setReportingMessage(hiringReportToOtherReport);
  } else {
    useInsights().setReportingMessage({ header: '', message: '', beaconArticleId: '' });
  }
};

export const checkPermissionsOrRedirect = (authDataStore, permissions, redirectTo = 'home') => (to, from, next) => {
  if (authDataStore.checkRbacPermissions(permissions)) {
    return next();
  }

  return next({ name: redirectTo });
};

export const checkOneOfPermissionsOrRedirect = (
  authDataStore,
  permissions,
  redirectTo = 'home',
) => (to, from, next) => {
  if (authDataStore.checkOneOfPermissions(permissions)) {
    return next();
  }

  return next({ name: redirectTo });
};

export const newReportsMiddleware = (authDataStore) => (to, from, next) => {
  routingFromHiringReport({ to, from });
  checkPermissionsOrRedirect(authDataStore, ['viewProcessInsightsGender'], 'recruiting-performance')(to, from, next);
};

export const demographicSurveyReportMiddleware = (authDataStore) => (to, from, next) => {
  routingFromHiringReport({ to, from });
  if (authDataStore.authData.isApplicationReportingEnabled && authDataStore.isDemographicSurveyReportVisible) {
    next();
  } else {
    next({ name: 'recruiting-performance' });
  }
};

export const demographicReportPermissionsMiddleware = (authDataStore) => (to, from, next) => {
  if (
    authDataStore.integrated
      && authDataStore.authData.canDemographicSurveyReport
      && authDataStore.authData.demographicSurveyReportVersion === DEMOGRAPHIC_SURVEY_SHOW
  ) {
    next();
  } else {
    next({ name: 'administrators' });
  }
};

export const hiringReportMiddleware = (authDataStore) => (to, from, next) => {
  if (authDataStore.authData.isApplicationReportingEnabled) {
    if (
      from.path.startsWith('/insights')
      && ![
        'language-snapshot',
        'usage',
        'content-snapshot',
        'weekly-snapshot',
        'compliance-report',
        'employer-brand-report',
        'job-performance-report',
      ].includes(from.name)
    ) {
      useInsights().setReportingMessage(otherReportToHiringReport);
    } else {
      useInsights().setReportingMessage({ header: '', message: '', beaconArticleId: '' });
    }

    next();
  } else {
    next({ name: 'recruiting-performance' });
  }
};
